const middleware = {}

middleware['pay'] = require('../middleware/pay.js')
middleware['pay'] = middleware['pay'].default || middleware['pay']

middleware['redirect'] = require('../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

middleware['register'] = require('../middleware/register.js')
middleware['register'] = middleware['register'].default || middleware['register']

middleware['registered'] = require('../middleware/registered.js')
middleware['registered'] = middleware['registered'].default || middleware['registered']

middleware['wx'] = require('../middleware/wx.js')
middleware['wx'] = middleware['wx'].default || middleware['wx']

export default middleware
